import { defineStore } from 'pinia';

export type GeneralState = {
  messages: Map<string, string>;
  dataLoading: boolean;
  journeyName: string;
}

export const useGeneralStore = defineStore({
  id: 'generalStore',

  state: () => ({
    messages: new Map<string, string>(),
    dataLoading: true,
    journeyName: '',
  } as GeneralState),

  getters: {
    getMessages: (state) => state.messages,
  },
});
